import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, orderBy, query } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyAGe4tEALPi6kdBnAJo4uf-8omOQ4Nda-0",
  authDomain: "pathway-academy.firebaseapp.com",
  projectId: "pathway-academy",
  storageBucket: "pathway-academy.firebasestorage.app",
  messagingSenderId: "822490806225",
  appId: "1:822490806225:web:218ebd85b334fa140312f0",
  measurementId: "G-43HW36L0TK"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [categories, setCategories] = useState([]);

    useEffect(() => {
      fetchImages();
    }, []);

    const fetchImages = async () => {
      try {
        const q = query(collection(db, 'gallery'), orderBy('order', 'asc'));
        const querySnapshot = await getDocs(q);
        const imageList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setImages(imageList);
        
        // Extract unique categories
        const uniqueCategories = [...new Set(imageList.map(img => img.category).filter(Boolean))];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error('Error fetching images:', error);
      } finally {
        setLoading(false);
      }
    };

    const filteredImages = selectedCategory === 'all' 
      ? images 
      : images.filter(img => img.category === selectedCategory);

    const getCategoryCount = (category) => {
      return category === 'all' 
        ? images.length 
        : images.filter(img => img.category === category).length;
    };
    
    if (loading) {
      return (
        <section className="bg-gray-100 py-16">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-medium mb-8 text-center">Gallery</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[...Array(8)].map((_, index) => (
                <div key={index} className="aspect-square overflow-hidden rounded-lg shadow-md bg-gray-200 animate-pulse">
                  <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-medium mb-8 text-center">Gallery</h2>
          
          {/* Category Filters */}
          {categories.length > 0 && (
            <div className="flex flex-wrap justify-center gap-3 mb-8">
              <button
                onClick={() => setSelectedCategory('all')}
                className={`px-4 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === 'all'
                    ? 'bg-[#218581] text-white shadow-md'
                    : 'bg-white text-gray-700 hover:bg-gray-200'
                }`}
              >
                All ({getCategoryCount('all')})
              </button>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full font-medium capitalize transition-all ${
                    selectedCategory === category
                      ? 'bg-[#218581] text-white shadow-md'
                      : 'bg-white text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category} ({getCategoryCount(category)})
                </button>
              ))}
            </div>
          )}

          {images.length === 0 ? (
            <div className="text-center text-gray-500">
              <p className="text-xl">No images available yet</p>
            </div>
          ) : filteredImages.length === 0 ? (
            <div className="text-center text-gray-500">
              <p className="text-xl">No images in this category</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {filteredImages.map((image) => (
                <div key={image.id} className="aspect-square overflow-hidden rounded-lg shadow-md">
                  <img 
                    src={image.downloadURL} 
                    alt={image.title || image.originalName}
                    className="w-full h-full object-cover transition-transform hover:scale-105"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    );
  };
  

  export default Gallery;